import { Modal } from '@breuni-ui/bdk-modal';
import { safeDefine } from '@breuni-ui/safe-define';

export class EntsModal extends Modal {}

safeDefine('ents-modal', EntsModal);
